const $ = jQuery.noConflict();

function isTouchDevice() {
	return 'ontouchstart' in window || navigator.msMaxTouchPoints;
}
class MegaMenu {
	constructor() {
		this.menu = $('.main-header__nav');
		this.menuItems = this.menu.find('> .menu > .menu-item-type-post_type');
		this.menuItemsLinks = this.menuItems.find('> a');
	}

	static showMegaMenu() {
		// eslint-disable-next-line no-unused-expressions
		MegaMenu.hideMegaMenu;
		$(this).addClass('active');
		$('body').addClass('menu-active');
		const megaMenuWrapper = $(this).find('.mega-menu-wrapper');
		const megaMenuCols = megaMenuWrapper.find('[class*="col-"]');
		const timer =
			$('.main-header .mega-menu-background').height() !== 0 ? 0 : 250;

		MegaMenu.menuTimeout = setTimeout(() => {
			megaMenuCols.each((i, v) => {
				MegaMenu.animateItemsIn($(v).find('*'));
			});

			megaMenuWrapper.addClass('active');
			MegaMenu.animateMenuBackground(megaMenuWrapper.outerHeight());
		}, timer);
	}
	static toggleMenuDisplay() {
		const currentMenuNumber = $(this).attr('data-toggle-menu');
		MegaMenu.triggerMenuItemClick(currentMenuNumber);
	}

	static triggerMenuItemClick(e) {
		const primaryTitle = $('.mega-menu__primary-title');
		const megaMenuMenu = $('.mega-menu__menu');
		const megaMenuImages = $(
			'.mega-menu__content.primary .mega-menu__image'
		);
		primaryTitle.removeClass('active');
		megaMenuMenu.removeClass('active');
		megaMenuImages.removeClass('active');

		$(`.mega-menu__menu[data-menu="${e}"]`).addClass('active');
		$(`.mega-menu__primary-title[data-toggle-menu="${e}"]`).addClass(
			'active'
		);
		$(
			`.mega-menu__content.primary .mega-menu__image[data-menu-image="${e}"]`
		).addClass('active');
	}

	static hideMegaMenu(event) {
		clearTimeout(MegaMenu.menuTimeout);
		if (!event.target.classList.contains('menu-item-type-post_type')) {
			return;
		}
		$('body').removeClass('menu-active');

		// this.menuItems.removeClass('active');
		$('.main-header__nav > .menu > .menu-item-type-post_type').removeClass(
			'active'
		);

		$(this).removeClass('active');
		const activeMegaMenu = $('.mega-menu-wrapper.active');
		const activeMegaMenuItems = activeMegaMenu.find(
			'*:not(.one-column .mega-menu__image):not(.two-column .mega-menu__image):not(.three-column .mega-menu__image)'
		);
		const firstMegaMenuItem = $('.mega-menu__primary-title:first-child');
		const firstMegaMenuMenu = $('.mega-menu__menu:first-child');

		activeMegaMenu.removeClass('active');
		activeMegaMenuItems.removeClass('active');
		firstMegaMenuItem.addClass('active');
		firstMegaMenuMenu.addClass('active');

		MegaMenu.animateMenuBackground(0);
	}

	static hideMegaMenuOnTouch(e) {
		const container = $('.main-header__nav');
		if (
			!container.is(e.target) &&
			container.has(e.target).length === 0 &&
			$('.mega-menu-wrapper').hasClass('active')
		) {
			MegaMenu.hideMegaMenu();
		}
	}
	static animateItemsIn(items) {
		let delay = 0;
		items.each((i, v) => {
			delay += 0.04;
			$(v).css('transition-delay', `${delay}s`);
			$(v).addClass('active');
		});
	}
	static animateMenuBackground(height) {
		$('.main-header .mega-menu-background')
			.stop()
			.animate(
				{
					height: `${height}px`,
				},
				300
			);
	}
	bindEvents() {
		if (isTouchDevice()) {
			this.menuItemsLinks.on('click', this.toggleMegaMenu);
			$(document).on('click touchstart', MegaMenu.hideMegaMenuOnTouch);
		} else {
			$('.main-header__nav > .menu')
				// this.menu
				// 	.find('> .menu > .menu-item-type-post_type:not(.active)')
				.on(
					'click',
					'> .menu-item-type-post_type:not(.active)',
					MegaMenu.showMegaMenu
				);

			$('.main-header__nav > .menu').on(
				'click',
				'> .menu-item-type-post_type.active',
				MegaMenu.hideMegaMenu
			);

			$('.mega-menu__primary-title').on(
				'click',
				MegaMenu.toggleMenuDisplay
			);
		}

		$('.main-header__search-icon').on('click', function () {
			$('.trigger-search').addClass('active');
			$('.trigger-search .search-field__input').focus();
			$('body').addClass('active-search');
		});

		$('.main-header__nav .parent-menu-item-links-to').on(
			'click',
			function (e) {
				const thisLink = e.target.getAttribute('href');
				window.location.replace(thisLink);
			}
		);
	}
	toggleMegaMenu(e) {
		e.preventDefault();
		const megaMenuWrapper = $(this).next('.mega-menu-wrapper');

		if (megaMenuWrapper.hasClass('active')) {
			return;
		}

		const megaMenuCols = megaMenuWrapper.find('[class*="col-"]');

		MegaMenu.hideMegaMenu();
		megaMenuCols.each((i, v) => {
			MegaMenu.animateItemsIn($(v).find('*'));
		});

		megaMenuWrapper.addClass('active');
		MegaMenu.animateMenuBackground(megaMenuWrapper.outerHeight());
	}
	init() {
		this.bindEvents();
	}
}
export default new MegaMenu();
